export default __webpack_public_path__ + "static/media/search.c54bdcc5.svg";